export const SocialBarThemes = {
  light: 'light',
  dark: 'dark',
} as const;

export const SocialBarIconTestHook = 'icon';
